<template>
  <div class="currentIssueComponent" v-if="currentIssue">
    <div class="title">
        Current Issue: <br />
      <div class="sub-title">
        Volume {{currentIssue.volume}} &#44; Issue {{currentIssue.issue}}
      </div>
    </div>
    <div class="row justify-content-between">
      <div class="col mb-2 pr-0"><img width="207" :src="currentIssue.optimized_urls.small" /></div>
      <div class="col links">
        <router-link class="link" v-for="link in currentIssue.rubricLinks" :key="link.url" :to="link.url">{{link.text}}<i class="icon icon-color-arrow-right"></i></router-link>
      </div>
    </div>
  </div>
</template>
<script>
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'

  export default {
    name: 'sidebar-current-issue',
    mixins: [ UtilityMixin ],
    data () {
      return {
        currentIssue: false
      }
    },
    created () {
      this.$http.get(this.$store.state.dataUrlIssue).then(function (response) {
        var issue = response.body
        var unique = function (arr) {
          var nArray = []
          for (var i = 0; i < arr.length; i++) {
            if (!nArray.find(function (item) { return item.text === arr[i].text })) {
              nArray.length += 1
              nArray[nArray.length - 1] = arr[i]
            }
          }
          return nArray
        }

        issue.rubricLinks = unique(
          issue.articles.map(
            function (item) {
              return {
                url: '/issue/volume/' + issue.volume + '/number/' + issue.issue + '#' + item.article_type.nlm_type,
                text: item.article_type.name
              }
            }
          )
        )
        this.currentIssue = issue
      }, function () {
      })
    }
  }
</script>
<style scoped lang="scss">
  .currentIssueComponent {
    margin-bottom: 8px;
  }
  .title {
    margin-top: 15px;
    font-family: 'Merriweather';
    font-size: 15px;
    font-style: italic;
    line-height: 1.1;
    color: $grey-font;
    .sub-title {
      font-size: 20px;
      line-height: 1.47;
      color: $accent-color-2;
      margin-bottom: 15px;
    }
  }
  .links {
    min-width: 140px;
  }
  .link {
    font-size: 14px;
    font-family: 'Open Sans';
    border-bottom: 1px solid #dedede;
    display: block;
    line-height: 32px;
    position: relative;
    .icon {
      margin-left: 10px;
    }
    &:hover {
      text-decoration: none;
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarCurrentIssueComponent.vue?416e6ded